import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../app.state';
import { toggleOutlines } from '../../../visual/visual.actions';

@Component({
  selector: 'nns-outline-btn',
  styles: [`
    .nns-btn-wrapper{
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: #F5F5F5;
      border-radius: 50%;
    }
    nns-icon{
      min-width: 16px;
      min-height: 16px;
      width: 16px!important;
      height: 16px!important;
    }
    :host-context(.nns-theme-night) :host{
      background-color: rgba(0,0,0, 0.2);
    }
  `, `
    :host-context(.nns-theme-night) .nns-btn-wrapper{
      background-color: rgba(0,0,0, 0.2);
    }
  `],
  template: `
    <div class="nns-btn-wrapper" (click)="onClick()">
      <nns-icon icon="hamburger" *ngIf="!isActive"></nns-icon>
      <nns-icon icon="hamburger-color" *ngIf="isActive"></nns-icon>
    </div>
  `
})
export class OutlineBtnComponent {
  @Input() isActive;

  constructor(
    private _store: Store<IAppState>,
  ) { }

  onClick() {
    this._store.dispatch(toggleOutlines());
  }
}
